import styled, {keyframes} from 'styled-components';

// Intentional AI-brand artwork colours, shared with the assistant orb; not themable tokens.
const RING_CYAN = '#46D8FF';
const RING_VIOLET = '#8A6EF2';
const RING_PINK = '#FF5CE8';
const RING_WIDTH = '2px';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const AiComposerBusyRing = styled.div.attrs({'aria-hidden': true})`
  position: absolute;
  inset: 0;
  z-index: ${({theme}) => theme.zIndices.CONTENT};
  pointer-events: none;
  border-radius: ${({theme}) => theme.radii.small};
  padding: ${RING_WIDTH};
  overflow: hidden;
  -webkit-mask:
    linear-gradient(black 0 0) content-box,
    linear-gradient(black 0 0);
  -webkit-mask-composite: xor;
  mask:
    linear-gradient(black 0 0) content-box,
    linear-gradient(black 0 0);
  mask-composite: exclude;

  &::before {
    content: '';
    position: absolute;
    inset: -50%;
    background: conic-gradient(${RING_CYAN}, ${RING_VIOLET}, ${RING_PINK}, ${RING_CYAN});
    animation: ${spin} 2.6s linear infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    &::before {
      animation: none;
    }
  }
`;
